<template>
  <div class="card border-0">
    <div class="card-header px-4 py-3 bg-white cursor-pointer collapsed"
         :id="'heading_' + booking.uuid" data-toggle="collapse"
         :data-target="'#collapse_' + booking.uuid" aria-expanded="false"
         :aria-controls="'collapse_' + booking.uuid">
      <div class="row font-poppins font-weight-light font-size-16 color-blue">
        <div class="col-12 col-md-3 col-lg-2">
          {{ booking.created_at }}
        </div>
        <div
            class="col-12 col-md-4 col-lg-6 font-weight-medium overflow-hidden text-nowrap text-truncate"
            :title="booking.title"
        >
          {{ booking.title }}
        </div>
        <div class="col-12 col-md-2 col-lg-2">
          {{ booking.total | toCurrency }}
        </div>
        <div class="col-12 col-md-3 col-lg-2 my-3 my-md-0 px-2 px-md-1 text-md-right">
          <div class="py-2 px-3 mr-md-2 font-size-11  font-weight-semibold badge"
               :class="'badge-' + booking.status.class">
            {{ booking.status.text }}
            <img src="/img/employee-dashboard/icon-check.svg"
                 v-if="booking.status.code === 1">
          </div>
        </div>
      </div>
    </div>

    <div
        :id="'collapse_' + booking.uuid"
        class="collapse pb-3 border-bottom"
        :aria-labelledby="'heading' + booking.uuid"
        data-parent="#bookingAccordion"
    >
      <div class="col font-poppins font-weight-light color-dark-blue py-0 px-4">
        <div class="row font-poppins font-weight-light font-size-16 color-blue">
          <div class="col-5 col-md-3 col-lg-2">
            {{ Lang.get('employeedashboard::pages/bookings/index.booking') }}:
          </div>
          <div class="col-7 col-md-9 col-lg-10 font-weight-light">
            {{ booking.description }}
          </div>
        </div>

        <template v-if="statusCodeSupportsBookingNumber(booking.status.code) || showBookingStartDate(booking.start_date, booking.status.code)">
          <div class="row my-2 my-md-0 font-poppins font-weight-light font-size-16 color-blue">

            <template v-if="statusCodeSupportsBookingNumber(booking.status.code)">
              <template v-if="booking.bookings_number">
                <div class="col-5 col-md-3 col-lg-2">
                  {{ Lang.get('employeedashboard::pages/bookings/index.bookings_number')}}:
                </div>
                <div class="col-7 col-md-9 col-lg-10">
                  {{ booking.bookings_number }}
                </div>
              </template>

              <template v-if="showBookingStartDate(booking.start_date, booking.status.code)">
                <div class="col-5 col-md-3 col-lg-2">
                  {{ Lang.get('employeedashboard::pages/bookings/index.start_date') }}:
                </div>
                <div class="col-7 col-md-9 col-lg-10">
                  {{ booking.start_date }}
                </div>
              </template>
            </template>

          </div>
        </template>
        <div class="row my-3 my-lg-0 font-poppins font-weight-light font-size-16 color-blue">
          <div class="col-5 col-md-3 col-lg-2">
            {{ Lang.get('employeedashboard::pages/bookings/index.order_specification') }}:
          </div>
          <div class="col-7 col-md-9 col-lg-10 font-weight-light">
            <a :href="route('nl.employeedashboard.bookings.download.specification',{'order_as_uuid': booking.uuid})"
                target="_blank"
                rel="noopener"
                class="font-poppins font-weight-light font-size-16 color-blue"
                :title="Lang.get('employeedashboard::pages/bookings/index.order_specification_download')"
            >
              <span class="font-poppins font-weight-light font-size-18 color-blue">
                <img src="/img/employee-dashboard/icon-download.svg" class="download-icon">
              </span>
              {{ Lang.get('employeedashboard::pages/bookings/index.order_specification_download') }}
            </a>
          </div>
        </div>
        <template v-if="booking.cancellable">
          <div class="row">
            <div class="col-12 text-right">

              <!-- Trigger the modal link -->
              <modal-trigger-link
                :is-disabled="booking.orderCancelRequestExists"
                class="font-poppins color-blue "
                :data-target-id="'cancel-dialog_' + booking.uuid"
                :reset-errors="true"
                :label-name="booking.orderCancelRequestExists
                        ? Lang.get('employeedashboard::pages/bookings/index.cancellation_pending')
                        : Lang.get('employeedashboard::pages/bookings/index.cancel_booking')"
              />
            </div>

            <!--  Modal -->

            <dlr-custom-modal
              :title="Lang.get('employeedashboard::pages/bookings/index.cancel_modal.title')"
              :modal-id="'cancel-dialog_' + booking.uuid"
              :subbit-label-button="Lang.get('employeedashboard::pages/bookings/index.cancel_modal.send')"
            >
              <template #content>
                <p v-html="Lang.get('employeedashboard::pages/bookings/index.cancel_modal.description')"/>

                <div class="form-group mb-0">
                  <text-area
                    :id="'reason_' + booking.uuid"
                    v-model="cancelBookingForm.reason"
                    :label="Lang.get('employeedashboard::pages/bookings/index.form.reason_for_cancellation.label')"
                    :placeholder="Lang.get('employeedashboard::pages/bookings/index.form.reason_for_cancellation.placeholder')"
                    :error="$page.props.errors.reason"
                    :isRequired="true"></text-area>
                </div>
              </template>

              <template #footer>
                <button
                  :disabled="modalIsProcessing"
                  @click="submitCancel"
                  class="btn btn-primary btn-orange font-poppins font-weight-bold border-radius-19 px-5 mb-3 mt-3 col-sm-12 col-lg-7">
                  {{ Lang.get('employeedashboard::pages/bookings/index.cancel_modal.send') }}
                </button>
              </template>
            </dlr-custom-modal>

          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import ModalTriggerLink from '@/Shared/Modal/ModalTriggerLink'
import ModalHideButton from "@/Shared/Modal/ModalHideButton";
import FormError from "@/Shared/FormError";
import DlrCustomModal from '@/Shared/Modal/DlrCustomModal';
import TextArea from "@/Shared/TextArea";

export default {
    name: "BookingAccordionRow",
    components: {
        ModalTriggerLink,
        ModalHideButton,
        FormError,
        DlrCustomModal,
        TextArea,
    },
    props: {
        booking: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            cancelBookingForm: this.$inertia.form({
                booking_uuid: this.booking.uuid,
                reason: null,
            }),

            /**
             * See \App\Models\Orders\Order.php for available statuses.
             */
            supportedStatusCodesForBookingNumber: [1, 4],
            supportedStatusCodesForStartDate: [1],
        }
    },
    methods: {
        statusCodeSupportsBookingNumber(status) {
            return this.supportedStatusCodesForBookingNumber.includes(status)
        },
        showBookingStartDate(startDate, status) {
            return startDate && this.supportedStatusCodesForStartDate.includes(status)
        },
        submitCancel() {
            this.cancelBookingForm.clearErrors();
            const uri = this.route('nl.employeedashboard.bookings.cancelOrder', {order_as_uuid: this.booking.uuid});
            this.cancelBookingForm.post(uri, {
                onSuccess: () => {
                    if (!this.cancelBookingForm.hasErrors) {
                        $('.modal').modal('hide');
                    }
                }
            });
        }
    },
    computed: {
        modalIsProcessing() {
            return this.cancelBookingForm.processing;
        },
    },
}
</script>
